import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { detectLocale } from './i18n/locale';
import { loadCatalog } from './i18n/catalog';

(function initProcessPolyfillForBrowser() {
  if (typeof window === 'undefined' || typeof window.process !== 'undefined') {
    return;
  }
  var nodeEnv = 'development';
  try {
    if (typeof process !== 'undefined' && process && process.env && process.env.NODE_ENV) {
      nodeEnv = process.env.NODE_ENV;
    }
  } catch (_e) {
    /* noop */
  }
  window.process = { env: { NODE_ENV: nodeEnv } };
})();

// Load the translation catalog before the first paint. Rendering first and
// swapping strings afterwards would show German visitors a flash of English.
// loadCatalog never rejects — a failed load degrades to English.
loadCatalog(detectLocale(window.location.pathname)).then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
